<template>
  <div>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card class="pa-3">
          <v-layout row wrap>
          <v-flex  md3 class="pl-1">
            <v-autocomplete
              label="Company"
              v-model="reportFilters.company_id"
              :items="companyTV"
              hide-details
              hide-selected
              item-text="text"
              item-value="value"
              outline
            >
            </v-autocomplete>
          </v-flex>

            <v-flex md3 class="pl-1">
              <v-menu
                v-model="invoiceDateMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="reportFilters.date"
                    label="Date from"
                    readonly
                    outline
                    required
                    :rules="requiredRules"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="reportFilters.date"
                  @input="invoiceDateMenu = false"
                ></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex md3 class="pl-1">
              <v-menu
                v-model="invoiceDateMenu2"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="reportFilters.date2"
                    label="Date To"
                    readonly
                    outline
                    required
                    :rules="requiredRules"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  :min="reportFilters.date"
                  v-model="reportFilters.date2"
                  @input="invoiceDateMenu2 = false"
                ></v-date-picker>
              </v-menu>
            </v-flex>
            <!-- <v-flex md6 class="text-xs-right">
              <v-tooltip left>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    color="primary"
                    fab
                    small
                    dark
                    @click="isSearchModal = true"
                  >
                    <v-icon>search</v-icon>
                  </v-btn>
                </template>
                <span>Advance Search</span>
              </v-tooltip>
            </v-flex> -->
          </v-layout>

          <ListLoader v-if="isLoadingContent"></ListLoader>
          <div class="simple-table-container" id="invoice-dues-report" v-else>
            <div class="hidden-screen-only report-header text-center">
              <div class="head">
                {{ settings && settings.company_name }}
              </div>
              <div class="address">
                {{ settings && settings.company_address }}
              </div>
              <hr />
              <br />
              <div class="title">
                 Report for {{selectedCompanyName}} -
                {{
                  reportFilters.date == reportFilters.date2
                    ? reportFilters.date
                    : `${reportFilters.date} to ${reportFilters.date2}`
                }}
              </div>
            </div>
            <table class="table table-bordered">
              <tr>
                <th>Invoice No.</th>
                <th>Date</th>
                <!-- <th>Company</th> -->
                <th>Coordinator</th>
                <th>Client</th>
                <th>Project</th>
                <th>Amount</th>
                <th>VAT</th>
                <th>Commission</th>
                <th>Expense</th>
                <th>Balance</th>
              </tr>
              <tr v-for="item in invoices" :key="`inv${item.id}`">
                <td>{{ item.invoice_number }}</td>
                <td>{{ item.invoice_date }}</td>
                <!-- <td>{{ item.companies___name }}</td> -->
                <td>{{ item.coordinators___name }}</td>
                <td>{{ item.clients___name }}</td>
                <td>{{ item.client_project_name }}</td>
                <td>{{ item.amount }}</td>
                <td>{{ item.vat_amount }}</td>
                <td>{{ item.commission_amount }}</td>
                <td>
                  <strong>{{ item.expense_amount }}</strong><br>
                  <span v-for="ieg in invoiceExpensesGroup[item.id]" :key="`invexp${ieg.account_head_id}`">
                  {{ ieg.account_heads___title }} -- {{ ieg.company_expense }} <br>
                  </span>
                </td>
                <td>{{ item.balance_amount }}</td>
              </tr>
              <tr>
                <td colspan="5"></td>
                <td>
                  <strong>{{ invoiceAmountSum }}</strong>
                </td>
                <td>
                  <strong>{{ vatAmountSum }}</strong>
                </td>
                <td>
                  <strong>{{ commissionSum }}</strong>
                </td>
                <td>
                  <strong>{{ expenseSum }}</strong>
                </td>
                <td>
                  <strong>{{ balanceSum }}</strong>
                </td>
              </tr>
              <tr>
                <td colspan="10" class="report-sum text-center">
                  Company specific Expenses
                </td>
              </tr>
              <tr v-for="item in data.company_expenses" :key="`coexp${item.account_head_id}`">
                <td colspan="9">{{ item.account_heads___title }}</td>
                <td>{{ item.company_expense }}</td>
              </tr>
              <tr>
                <td colspan="9">Company non specific/common Expenses (Total {{ mA(data.non_company_expenses) }})</td>
                <td>{{ companyShareExpense }}</td>
              </tr>
              <tr>
                <td colspan="9"><strong>Total Expenses</strong></td>
                <td><strong>{{ nonInvoiceExpenseSum }}</strong></td>
              </tr>
              
              <tr>
                <td colspan="10" class="report-sum text-center">
                  Profit/Loss 
                  <strong v-if="profitAmount>0" style="color:green;">(Profit)</strong> 
                  <strong v-if="profitAmount<0" style="color:red;">(Loss)</strong> 
                  &nbsp;&nbsp; {{ mA(Math.abs(profitAmount)) }}
                </td>
              </tr>
            </table>
          </div>
          <v-card-actions>
            <v-btn flat @click="print()">Print</v-btn>
            <!-- <v-btn flat >Explore</v-btn> -->
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
    <!-- <v-dialog v-model="isSearchModal" scrollable persistent max-width="500px">
      <AdvanceSearch
        :rfilters="reportFilters"
        :hide="['bill_type', 'account_head', 'date', 'date2', 'money_account']"
        @cancelled="isSearchModal = false"
      />
    </v-dialog> -->
  </div>
</template>

<script>
import { ContentLoader, ListLoader } from "vue-content-loader";
// import AdvanceSearch from "../SearchModal";
import { columnSum, valueToText, getTV } from "../../mdsir/MdsirUtils";
import { PROJECT_OWNER, MYSQL_DATE_FORMAT } from "../../mdsir/const";
import * as _ from "underscore";

export default {
  components: {
    ContentLoader,
    ListLoader,
    // AdvanceSearch,
  },
  data: () => ({
    isSearchModal: false,
    isLoadingContent: false,
    invoiceDateMenu: false,
    invoiceDateMenu2: false,
    reportFilters: {
      date: null,
      date2: null,
      company_id: ""
    },
    data: [],
    companies: [],
  }),

  computed: {
    companyTV() {
      return getTV(this.companies, { textField: "name", valueField: "id", isDeselect:false });
    },
    invoices() {
      const { invoices } = this.data;
      return (invoices || []).map((r) => {
        const invoiceProfit = r.amount - (r.vat_amount + r.expense_amount);

        let commission_amount = 0;
        if (
          r.coordinator_commission_parcent &&
          r.coordinator_commission_parcent > 0
        ) {
          commission_amount = (invoiceProfit * r.coordinator_commission_parcent) / 100;
        }

        const balance_amount = invoiceProfit - commission_amount;

        return { ...r, commission_amount, balance_amount };
      });
    },
    commissionSum() {
      return columnSum(this.invoices, "commission_amount");
    },
    expenseSum() {
      return columnSum(this.invoices, "expense_amount");
    },
    balanceSum() {
      return columnSum(this.invoices, "balance_amount");
    },
    vatAmountSum() {
      return columnSum(this.invoices, "vat_amount");
    },
    invoiceAmountSum() {
      return columnSum(this.invoices, "amount");
    },
    nonInvoiceExpenseSum() {
      return columnSum(this.data.company_expenses, "company_expense") + this.companyShareExpense;
    },
    profitAmount() {
      return this.balanceSum - this.nonInvoiceExpenseSum;
    },
    invoiceExpensesGroup() {
      return _.groupBy(this.data.invoice_expenses, "invoice_id");
    },
    companyShareExpense() {
      const non_company_expenses = this.data.non_company_expenses || 0;
      return non_company_expenses > 0 ?  non_company_expenses / this.data.company_count : 0;
    },
    selectedCompanyName(){
      const s = this.companyTV.find(r => r.value == this.reportFilters.company_id);
      return s && s.text ? s.text : "";
    }
  },

  watch: {
    reportFilters: {
      handler: function (val, oldVal) {
        this.getDataFromApi();
      },
      deep: true,
    },
  },

  created() {},

  mounted() {
    this.reportFilters.date = this.$moment().startOf("month").format(MYSQL_DATE_FORMAT);
    this.reportFilters.date2 = this.$moment().endOf("month").format(MYSQL_DATE_FORMAT);
    // this.getDataFromApi();
    this.loadCompanies();
  },

  methods: {
    loadCompanies() {
      this.get("/companies").then((response) => {
        this.companies = response.data.data;
      });
    },
    async getDataFromApi() {
      const { company_id, date, date2 } = this.reportFilters;
      if(!(company_id && date && date2)){
        return;
      }

      this.isLoadingContent = true;
      const res = await this.get("/company_report", this.reportFilters);

      this.data = res.data;
      // console.log("report data:", res.data);
      this.isLoadingContent = false;
    },
    print() {
      this.$htmlToPaper("invoice-dues-report");
    },
    projectOwner(value) {
      return valueToText(PROJECT_OWNER, value);
    },
    overIncome(item) {
      return item.base_service_charge && item.base_service_charge > 0
        ? item.service_charge - item.base_service_charge
        : 0;
    },
  },

  beforeDestroy() {},
};
</script>

<style scoped>
.simple-table-container {
  overflow: auto;
}
.table {
  border-collapse: collapse;
  width: 100%;
}
.table th {
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: left;
  background-color: #bebebe;
}

.table td,
.table th {
  border: 1px solid #ddd;
  padding: 8px;
}

.table td.report-sum {
  padding: 6px;
  text-align: center;
  background-color: #0f0f0f0e;
  font-size: 20px;
  font-weight: bold;
}
</style>
